/* @flow */

import swal from '../../swal';

const preConfirmAlterarEtapaEntrega = () => {
    const entregador = document.getElementById('entregador-atendimento');
    const loggi = document.getElementById('loggi-atendimento');
    if (entregador instanceof HTMLSelectElement
        && loggi instanceof HTMLInputElement
        && !loggi.checked
        && !entregador.value
    ) {
        swal.showValidationMessage('Selecione uma opção de entrega');
    }
};

export default preConfirmAlterarEtapaEntrega;
